define('views/modules/supervisor/supervisor-icon',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/modules/supervisor/supervisor-icon.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TSupervisorIcon
) {

    var VSupervisorIcon = Backbone.View.extend({
        template: TSupervisorIcon,

        regions: {
            tooltip: '[data-toggle="tooltip"]',
        },

        initialize: function(opt) {
            this.options = _.extend({
                tooltip: {
                    placement: "auto right"
                }
            }, opt);
        },

        render: function() {
            if (this.hasTooltip()) {
                this.$(this.regions.tooltip).tooltip('destroy');
            }

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));
            this.generateZones();

            if (this.hasTooltip()) {
                this.zone.$tooltip.tooltip(this.options.tooltip);
            }

            return this;
        },

        hasTooltip: function() {
            return Boolean(this.options.tooltip);
        },

    });

    return VSupervisorIcon;

});

